import SelectInput from 'components/molecules/select-input'
import { useQueryParams } from 'hooks/useQueryParams'
import React from 'react'
import { order } from 'tailwindcss/defaultTheme'

export interface SelectSortOptionsFilterProps {
  className?: string
}

const SelectSortOptionsFilter: React.FC<SelectSortOptionsFilterProps> = ({
  className,
}) => {
  const { query, updateQuery } = useQueryParams<SortType>()
  const { orderBy, orderDirection } = query
  const value =
    order && orderDirection
      ? orderOptions.find(
          (option) =>
            option.value.orderBy === orderBy &&
            option.value.orderDirection === orderDirection
        )
      : null

  return (
    <SelectInput
      className={className}
      placeholder="Mais Relevantes"
      isSearchable={false}
      isClearable={true}
      value={value}
      options={orderOptions}
      onChange={(option) => {
        updateQuery(option?.value || { orderBy: null, orderDirection: null })
      }}
    />
  )
}

export default SelectSortOptionsFilter

type OptionType = {
  label: string
  value: SortType
}
type SortType = {
  orderBy?: string
  orderDirection?: 'asc' | 'desc'
}

const orderOptions: OptionType[] = [
  {
    label: 'Nome de A-Z',
    value: { orderBy: 'name', orderDirection: 'asc' },
  },
  {
    label: 'Nome de Z-A',
    value: { orderBy: 'name', orderDirection: 'desc' },
  },
  {
    label: 'Menor Preço',
    value: { orderBy: 'priceWithDiscount', orderDirection: 'asc' },
  },
  {
    label: 'Maior Preço',
    value: { orderBy: 'priceWithDiscount', orderDirection: 'desc' },
  },
]
